import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';

import { Cargo } from '@app/core/models/questionario-cargo';
import { Concurso } from '@core/models/concurso';
import { ConcursoApiService } from './concurso-api.service';
import { FiltroConcurso } from '../tabela-concurso/filtro';
import { FiltroQuestionarioCargo } from '../tabela-questionario-cargo/filtro-questionario-cargo';
import { Observable } from 'rxjs';
import { OportunidadesApiService } from '@app/core/services/oportunidades-api.service';
import { PerfilProfissiograficoApiService } from '@app/core/services/perfil-profissiografico-api.service';
import { ResultadoQuestionarioCargo } from '@app/core/models/resultado-questionario-cargo';
import { SituacaoQuestionarioCargo } from '@app/core/models/perfil-profissiografico/situacao-questionario-cargo';
import { environment } from '@environments/environment';

@Injectable({
	providedIn: 'any'
}) 
export class QuestionarioCargoApiService  implements OnInit {
	
	URL_CARGO = environment.HOST_OPORTUNIDADE + '/' + 'cargo';
	orgaos$?: Observable<any[]>;
	cargos$?: Observable<Cargo[]>;
	concursos$?: Observable<any>;
	situacoes$?: Observable<SituacaoQuestionarioCargo[]>;

	constructor(private http: HttpClient, private pesquisarConcursoApi: ConcursoApiService, private pesquisarCargoPerfilApi: PerfilProfissiograficoApiService, private oportunidadesService: OportunidadesApiService) {}

	ngOnInit(): void {
		this.carregarConcursos();
		this.carregarSituacoes();
	}

	obterConcursos(concurso: Concurso, pagina?: number, tamanho?: number): Observable<any[]> {
		return this.pesquisarConcursoApi.obterConcursos(concurso, pagina, tamanho);
	}

	obterConcurso(id: number): Observable<Concurso> {
		return this.pesquisarConcursoApi.obterConcurso(id);
	}

	obterCargos(idConcurso?: number, codigoOrgao?: number): Observable<Cargo[]> {
		let params = new HttpParams();
		if (idConcurso)
			params = params.append('id_concurso', idConcurso);
		if (codigoOrgao)
			params = params.append('codigo_orgao', codigoOrgao);

		return this.http.get<Cargo[]>(
			`${environment.PERFIL_PROFISSIOGRAFICO}/cargo`,
			{
				params: params
			}
		);
	}

	pesquisarCargos(filtro: FiltroQuestionarioCargo): Observable<ResultadoQuestionarioCargo> {
		let params = new HttpParams();
		params = params.append('page', filtro.page);
		params = params.append('size', filtro.size);
		if (filtro.idConcurso)
			params = params.append('id_concurso', filtro.idConcurso);
		if (filtro.codigoOrgao)
			params = params.append('codigo_orgao', filtro.codigoOrgao);
		if (filtro.codigoCargo)
			params = params.append('codigo_cargo', filtro.codigoCargo);
		if (filtro.nomeCargo)
			params = params.append('nome_cargo', filtro.nomeCargo);
		if (filtro.situacao)
			params = params.append('situacao', filtro.situacao);
		if (filtro.dataInicioLiberacao)
			params = params.append('data_inicio_liberacao', filtro.dataInicioLiberacao);
		if (filtro.dataFimLiberacao)
			params = params.append('data_fim_liberacao', filtro.dataFimLiberacao);
		
		return this.http.get<ResultadoQuestionarioCargo>(
			`${environment.PERFIL_PROFISSIOGRAFICO}/pesquisar-perfil-cargo`,
			{
				params: params
			}
		);
	}

	obterCargo(codigoConcurso: string, codigoOrgao: number, codigoCargo: number): Observable<Cargo> {
		const url = this.URL_CARGO + '/consultar-cargo';
		let params = new HttpParams();
		params = params.append('codigo_concurso', codigoConcurso);
		params = params.append('codigo_orgao', codigoOrgao);
		params = params.append('codigo_cargo', codigoCargo);
		return this.http.get<Cargo>(url, {
			params: params
		});
	}

	incluirCargo(cargo: Cargo) {
		const novoCargo = this.cargoEdicaoParametro(cargo);
		return this.http.post(this.URL_CARGO, novoCargo);
	}

	alterarCargo(id: number, cargo: Cargo) {
		const url = this.URL_CARGO + '/' + id.toString();
		const cargoAlterado = this.cargoEdicaoParametro(cargo);
		return this.http.put(url, cargoAlterado);
	}

	excluirCargo(id: number) {
		const url = this.URL_CARGO + '/' + id.toString();
		return this.http.delete(url);
	}

	listarSituacoes(): Observable<SituacaoQuestionarioCargo[]>  {
		return this.pesquisarCargoPerfilApi.getSituacaoQuestionario();
	}

	carregarConcursos(): void {
		this.concursos$ = this.obterConcursos(new Concurso(), 1, 100);
	}

	carregarOrgaos(idConcurso?: number): void {
		if (idConcurso)
			this.orgaos$ = this.pesquisarCargoPerfilApi.getOrgaosConcurso(idConcurso);
		else
			this.orgaos$ = this.oportunidadesService.orgaos();
	}

	carregarCargos(idConcurso: number, codigoOrgao?: number): void {
		this.cargos$ = this.obterCargos(idConcurso, codigoOrgao);
	}
	
	carregarSituacoes(): void {	
		if (!this.situacoes$) {
			this.situacoes$ = this.listarSituacoes();
		}
	}

	tratarDadosConcurso(itens: any[], filtroSituacao?: string): any[] {
		let resultadoConcursos = [];
		let nomeConcurso =  '';
		for (const item of itens) {
			nomeConcurso = item.nome + ' - ' + item.codigo;
			const resultadoTratado = {
				label: nomeConcurso,
				value: item.id,
				situacao: item.situacao.codigo
			};
			if ( !filtroSituacao || resultadoTratado.situacao === filtroSituacao ) {
				resultadoConcursos!.push(resultadoTratado);
			}
		}
		return resultadoConcursos;
	}

	tratarDadosOrgao(itens: any[]): any[] {
		let resultadoOrgaos = [];
		let nomeProp =  '';
		let codigoProp = '';
		let nome = '';
		let codigo = null;
		let situacao = null;
		let sigla = null;

		if (itens.length > 0) {
			nomeProp = ('nomeOrgao' in itens[0]) ? 'nomeOrgao' : 'nome';
			codigoProp = ('codigoOrgao' in itens[0]) ? 'codigoOrgao' : 'codigoSiape';
		}
		for (const item of itens) {
			nome = item[nomeProp];
			codigo = item[codigoProp];
			situacao = ('situacao' in item) ? item['situacao'] : null;
			sigla = ('sigla' in item) ? item['sigla'] : null;
			resultadoOrgaos.push({ name: this.descricaoOrgao(nome, sigla, situacao, codigo), code: codigo });
		}
		resultadoOrgaos.sort((a, b) => a.name.localeCompare(b.name));
	
		return resultadoOrgaos;
	}

	private descricaoOrgao(nome: string, sigla?: string, situacao?: string, codigoSiape?: number): string {
		let nomeFormatado =  codigoSiape ? codigoSiape.toString() + ' - ' : '';
		nomeFormatado += sigla ? sigla + ' - ' : ''; 
		nomeFormatado += nome;
		if (situacao) {
			if (situacao === 'PENDENTE_EXTINCAO_SIAPE') return nomeFormatado + ' (Pendente de extinção)';
			else if (situacao === 'DESATIVADO_EXTINTO') return nomeFormatado + ' (Extinto)';
		}
		return nomeFormatado;
	}

	private cargoEdicaoParametro(cargo: Cargo): any {
		const cargoParametros = { 'nome_cargo'  : cargo.nomeCargo, 
								  'codigo_cargo': cargo.codigoCargo,
								  'codigo_orgao': cargo.codigoOrgao,
								  'id_concurso' : cargo.idConcurso }
		return cargoParametros;
	}
}
